import { useColor } from './useColor';
export function useColorBoard() {
  var manager = useColor();
  return manager.getColor().getRGBA();
}